export default __webpack_public_path__ + "edaac913f891c7d5a6ee091d9635cb8c.svg";